
import { createSlice } from '@reduxjs/toolkit';

import { assignVendors, getActionSummary, getOrderActionDraft, getOrders, getSkuLabelsChallan, getVendorAllocations, getVendors, indiaSupplyUpdateOrder, moveOrder, revertOrderAction, sendToProduction, updateOrderFile, updateProductionOnHoldOrders, updateVendor } from '../../apis';
import { completeCAD } from './api';
import { orderManagementScreenConstants } from './constants';

export const InHouseOrderManagement = createSlice({
    name: 'inHouseOrderManagement',
    initialState: {
        isLoading: false,
        data : [],
        viewActionSummaryData: {},
        orderActionDraftData: [],
        vendorsListData: [],
        assignVendorSuccess: false,
        sentToProductionSuccess: false,
        getSkuLabelsChallanSuccess: false,
        moveToOutsourceSuccess: false,
        moveToInhouseSuccess: false,
        recoverRejectedSuccess: false,
        saveDraftSuccess: false,
        updateOrderSuccess: false,
        updateOrderFileSuccess: false,
        updateProductionOnHoldSuccess: false,
        revertOrderActionSuccess: false,
        updateVendorSuccess: false,
        completeCADSuccess: false,
        error: '',
    },

    reducers: {
        clearOutsourceSuccess: (state, action) => {
            return {
                ...state,
                moveToOutsourceSuccess: action.payload
            }
        },
        clearInHouseSuccess: (state, action) => {
            return {
                ...state,
                moveToInhouseSuccess: action.payload
            }
        },
        clearRecoverRejectedSuccess: (state, action) => {
            return {
                ...state,
                recoverRejectedSuccess: action.payload
            }
        },
        clearSaveDraftSuccess: (state, action) => {
            return {
                ...state,
                saveDraftSuccess: action.payload
            }
        },
        clearUpdateOrderSuccess: (state, action) => {
            return {
                ...state,
                updateOrderSuccess: action.payload
            }
        },
        updateVendorsList: (state, action) => {
            return {
                ...state,
                vendorsListData: action.payload
            }
        },
        clearAssignVendorSuccess: (state, action) => {
            return {
                ...state,
                assignVendorSuccess: action.payload
            }
        },
        clearSentToProductionSuccess: (state, action) => {
            return {
                ...state,
                sentToProductionSuccess: action.payload
            }
        },
        clearGetSkuLabelsChallanSuccess: (state, action) => {
            return {
                ...state,
                getSkuLabelsChallanSuccess: action.payload
            }
        },
        clearUpdateOrderFileSuccess: (state, action) => {
            return {
                ...state,
                updateOrderFileSuccess: action.payload
            }
        },
        clearUpdateProductionOnHoldSuccess: (state, action) => {
            return {
                ...state,
                updateProductionOnHoldSuccess: action.payload
            }
        },
        clearRevertOrderSuccess: (state, action) => {
            return {
                ...state,
                revertOrderActionSuccess: action.payload
            }
        },
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getOrders.pending, (state, action) => {
            state.isLoading = true;
            // state.data = {}
        })
        builder.addCase(getOrders.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getActionSummary.pending, (state, action) => {
            state.isLoading = true;
            state.viewActionSummaryData = {}
        })
        builder.addCase(getActionSummary.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.viewActionSummaryData = action.payload.data
        })
        builder.addCase(getActionSummary.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getOrderActionDraft.pending, (state, action) => {
            state.isLoading = true;
            state.orderActionDraftData = {}
        })
        builder.addCase(getOrderActionDraft.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.orderActionDraftData = action.payload.data
        })
        builder.addCase(getOrderActionDraft.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(moveOrder.pending, (state, action) => {
            state.isLoading = true;
            state.moveToOutsourceSuccess = false
            if (action?.meta?.arg?.destination === 'OUTSOURCED') {
                state.moveToOutsourceSuccess = false
            } else if (action?.meta?.arg?.destination === 'IN_HOUSE') {
                state.moveToInhouseSuccess = false
            } else if (action?.meta?.arg?.source === orderManagementScreenConstants.REJECTED) {
                state.recoverRejectedSuccess = false
            }
        })
        builder.addCase(moveOrder.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            if (action?.meta?.arg?.destination === 'OUTSOURCED') {
                state.moveToOutsourceSuccess = true
            } else if (action?.meta?.arg?.destination === 'IN_HOUSE') {
                state.moveToInhouseSuccess = true
            } else if (action?.meta?.arg?.source === orderManagementScreenConstants.REJECTED) {
                state.recoverRejectedSuccess = true
            }
        })
        builder.addCase(moveOrder.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
            if (action?.meta?.arg?.destination === 'OUTSOURCED') {
                state.moveToOutsourceSuccess = false
            } else if (action?.meta?.arg?.destination === 'IN_HOUSE') {
                state.moveToInhouseSuccess = false
            } else if (action?.meta?.arg?.source === orderManagementScreenConstants.REJECTED) {
                state.recoverRejectedSuccess = false
            }
        })
        builder.addCase(indiaSupplyUpdateOrder.pending, (state, action) => {
            state.isLoading = true;
            if (action?.meta?.arg?.is_draft) {
                state.saveDraftSuccess = false
            } else {
                state.updateOrderSuccess = false
            }
        })
        builder.addCase(indiaSupplyUpdateOrder.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            if (action?.meta?.arg?.is_draft) {
                state.saveDraftSuccess = true
            } else {
                state.updateOrderSuccess = true
            }
        })
        builder.addCase(indiaSupplyUpdateOrder.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
            if (action?.meta?.arg?.is_draft) {
                state.saveDraftSuccess = false
            } else {
                state.updateOrderSuccess = false
            }
        })
        builder.addCase(getVendors.pending, (state, action) => {
            state.isLoading = true;
            state.vendorsListData = []
        })
        builder.addCase(getVendors.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.vendorsListData = action.payload.data?.map(vendor => ({...vendor, ...(vendor?.is_selectable && {isChecked: true}), value: vendor?.id}))
        })
        builder.addCase(getVendors.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(assignVendors.pending, (state, action) => {
            state.isLoading = true;
            state.assignVendorSuccess = false
        })
        builder.addCase(assignVendors.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.assignVendorSuccess = true
        })
        builder.addCase(assignVendors.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(sendToProduction.pending, (state, action) => {
            state.isLoading = true;
            state.sentToProductionSuccess = false
        })
        builder.addCase(sendToProduction.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.sentToProductionSuccess = true
        })
        builder.addCase(sendToProduction.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getSkuLabelsChallan.pending, (state, action) => {
            state.isLoading = true;
            state.getSkuLabelsChallanSuccess = false
        })
        builder.addCase(getSkuLabelsChallan.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.getSkuLabelsChallanSuccess = true
        })
        builder.addCase(getSkuLabelsChallan.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateOrderFile.pending, (state, action) => {
            state.isLoading = true;
            state.updateOrderFileSuccess = false
        })
        builder.addCase(updateOrderFile.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateOrderFileSuccess = true
        })
        builder.addCase(updateOrderFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateProductionOnHoldOrders.pending, (state, action) => {
            state.isLoading = true;
            state.updateProductionOnHoldSuccess = false
        })
        builder.addCase(updateProductionOnHoldOrders.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateProductionOnHoldSuccess = true
        })
        builder.addCase(updateProductionOnHoldOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(revertOrderAction.pending, (state, action) => {
            state.isLoading = true;
            state.revertOrderActionSuccess = false
        })
        builder.addCase(revertOrderAction.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.revertOrderActionSuccess = true
        })
        builder.addCase(revertOrderAction.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(updateVendor.pending, (state, action) => {
            state.isLoading = true;
            state.updateVendorSuccess = false
        })
        builder.addCase(updateVendor.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.updateVendorSuccess = true
        })
        builder.addCase(updateVendor.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(completeCAD.pending, (state, action) => {
            state.isLoading = true;
            state.updateVendorSuccess = false
        })
        builder.addCase(completeCAD.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.completeCADSuccess = true
        })
        builder.addCase(completeCAD.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        
    }
})

export const { clearErrorState, clearOutsourceSuccess, clearSaveDraftSuccess, clearUpdateOrderSuccess, clearInHouseSuccess, clearRecoverRejectedSuccess, clearAssignVendorSuccess, clearSentToProductionSuccess, updateVendorsList, clearUpdateOrderFileSuccess, clearUpdateProductionOnHoldSuccess, clearRevertOrderSuccess, clearGetSkuLabelsChallanSuccess, clear } = InHouseOrderManagement.actions

export default InHouseOrderManagement.reducer